// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import { Config } from 'react-awesome-query-builder';

export const config: Partial<Config> = {
    fields: {
        state: {
            label: 'State',
            type: 'select',
            operators: ['select_any_in', 'select_equals'], // ['select_equals', 'select_not_equals', 'select_any_in', 'select_not_any_in']
            valueSources: ['value'],
            fieldSettings: {
                listValues: [
                    { value: 'new', title: 'new' },
                    { value: 'in progress', title: 'in progress' },
                    { value: 'rejected', title: 'rejected' },
                    { value: 'completed', title: 'completed' },
                ],
            },
        },
        // stage: {
        //     label: 'Stage',
        //     type: 'select',
        //     operators: ['select_any_in', 'select_equals'],
        //     valueSources: ['value'],
        //     fieldSettings: {
        //         listValues: [
        //             { value: 'annotation', title: 'annotation' },
        //             { value: 'validation', title: 'validation' },
        //             { value: 'acceptance', title: 'acceptance' },
        //         ],
        //     },
        // },
        // dimension: {
        //     label: 'Dimension',
        //     type: 'select',
        //     operators: ['select_equals'],
        //     valueSources: ['value'],
        //     fieldSettings: {
        //         listValues: [
        //             { value: '2d', title: '2D' },
        //             { value: '3d', title: '3D' },
        //         ],
        //     },
        // },
        phase: {
            label: 'Phase',
            type: 'select',
            operators: ['select_any_in', 'select_equals'],
            valueSources: ['value'],
            fieldSettings: {
                listValues: [
                    { value: 'preinit', title: 'preinit' },
                    { value: 'phase0', title: 'phase0' },
                    { value: 'phase1a', title: 'phase1a' },
                    { value: 'phase1b', title: 'phase1b' },
                    { value: 'phase2a', title: 'phase2a' },
                    { value: 'phase2b', title: 'phase2b' },
                    { value: 'phase3a', title: 'phase3a' },
                    { value: 'phase3b', title: 'phase3b' },
                    { value: 'phase4a', title: 'phase4a' },
                    { value: 'phase4b', title: 'phase4b' },
                ],
            },
        },
        assignee: {
            label: 'Assignee',
            type: 'text', // todo: change to select
            valueSources: ['value'],
            fieldSettings: {
                // useAsyncSearch: true,
                // forceAsyncSearch: true,
                // async fetch does not work for now in this library for AntdConfig
                // but that issue was solved, see https://github.com/ukrbublik/react-awesome-query-builder/issues/616
                // waiting for a new release, alternative is to use material design, but it is not the best option too
                // asyncFetch: async (search: string | null) => {
                //     const users = await core.users.get({
                //         limit: 10,
                //         is_active: true,
                //         ...(search ? { search } : {}),
                //     });

                //     return {
                //         values: users.map((user: any) => ({
                //             value: user.username, title: user.username,
                //         })),
                //         hasMore: false,
                //     };
                // },
            },
        },
        updated_date: {
            label: 'Last updated',
            type: 'datetime',
            operators: ['between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
        },
        id: {
            label: 'ID',
            type: 'number',
            operators: ['equal', 'between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
            fieldSettings: { min: 0 },
            valueSources: ['value'],
        },
        task_id: {
            label: 'Task ID',
            type: 'number',
            operators: ['equal', 'between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
            fieldSettings: { min: 0 },
            valueSources: ['value'],
        },
        project_id: {
            label: 'Project ID',
            type: 'number',
            operators: ['equal', 'between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
            fieldSettings: { min: 0 },
            valueSources: ['value'],
        },
        task_name: {
            label: 'Task name',
            type: 'text',
            valueSources: ['value'],
            operators: ['like'],
        },
        project_name: {
            label: 'Project name',
            type: 'text',
            valueSources: ['value'],
            operators: ['like'],
        },
    },
};

export const localStorageRecentCapacity = 10;
export const localStorageRecentKeyword = 'recentlyAppliedJobsFilters';
export const predefinedFilterValues = {
    'Assigned to me': '{"and":[{"==":[{"var":"assignee"},"<username>"]}]}',
    'Not completed': '{"!":{"or":[{"==":[{"var":"state"},"completed"]},{"==":[{"var":"stage"},"acceptance"]}]}}',
};
